const state = {
	isUserLoggedIn: false,
	userAuthInfo: {},
	expiry: null,
	isAuthModalOpen: false,
	authModalTab: 1,

	
	isAlertModalOpen: false,
	isLoginModalOpen: false,
	isLoginSelectionModalOpen: false,
	isSignupSelectionModalOpen: false,
	isForgetPasswordModalOpen:false,
	LoginSelectionMode: undefined
}

export default state